export default function reviewActions() {
    return {
        isLiked: false,
        likeCount: 0,
        isHidden: false,
        processing: false,

        init() {
            // Required data attribute for like functionality
            if (!this.$el.dataset.likeUrl) {
                console.error('Missing required data attribute: data-like-url');
                return;
            }

            // Initialize state from data attributes
            this.isLiked = this.$el.dataset.isLiked === 'true';
            this.likeCount = parseInt(this.$el.dataset.likeCount || '0');
            this.isHidden = this.$el.dataset.isHidden === 'true';
        },

        async toggleLike() {
            if (this.processing) return;
            this.processing = true;

            try {
                const response = await fetch(this.$el.dataset.likeUrl, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        'Accept': 'application/json',
                    },
                });

                const data = await response.json();

                if (response.ok) {
                    this.isLiked = data.liked;
                    this.likeCount = data.likeCount;
                    
                    // Show success toast
                    this.$dispatch('toast', {
                        type: 'success',
                        message: data.message
                    });
                } else {
                    throw new Error(data.error || 'Failed to process like');
                }
            } catch (error) {
                // Show error toast
                this.$dispatch('toast', {
                    type: 'error',
                    message: error.message
                });
            } finally {
                this.processing = false;
            }
        },

        async toggleHidden() {
            if (this.processing) return;
            this.processing = true;

            try {
                const response = await fetch(this.$el.dataset.hideUrl, {
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        'Accept': 'application/json',
                    },
                });

                const data = await response.json();

                if (response.ok) {
                    this.isHidden = data.isHidden;
                    
                    // Show success toast
                    this.$dispatch('toast', {
                        type: 'success',
                        message: data.message
                    });
                } else {
                    throw new Error(data.error || 'Failed to update review visibility');
                }
            } catch (error) {
                // Show error toast
                this.$dispatch('toast', {
                    type: 'error',
                    message: error.message
                });
            } finally {
                this.processing = false;
            }
        }
    };
}
